import React from "react";
import { Trans } from "react-i18next";
import { find, sumBy, isUndefined } from "lodash";
import { formatNumber, formatCurrency, CurrencySymbol } from "services/util";
import { withProps } from "recompose";

const TaxPercent = ({ lineItem: { TaxType }, taxRates }) => {
  const taxType = find(taxRates, { TaxType });
  return taxType ? `${taxType.EffectiveRate}%` : null;
};

export const LineItems = ({
  invoice,
  taxRates,
  includeDiscount,
  EmptyCells,
}) => (
<div className="container-fluid m-0 p-0 text-center">
  <div className="mt-3 mb-4" style={{ maxWidth: "302px" }}>
    <table className="table table-sm items text-start" style={{fontSize:"0.8rem"}}>
      <thead >
        <tr>
          <td className="font-weight-bold c-text-start">
            <Trans>Description</Trans>
          </td>
          <td className="font-weight-bold c-text-start">
            <Trans>Quantity</Trans>
          </td>
          <td className="font-weight-bold c-text-start">
            <Trans>Unit Price</Trans>
          </td>
          <td className="font-weight-bold c-text-end">
            <Trans>Amount</Trans>
          </td>
        </tr>
      </thead>
      <tbody >
        {invoice.LineItems.map((i, idx) => (
          <>
          <tr key={idx}>
            <td style={{fontSize:"16px"}}>*{i.Description}</td>
            <td className="c-text-start">{formatNumber(i.Quantity)}</td>
            <td className="c-text-start">{formatCurrency(i.UnitAmount)}</td>
            <td className="c-text-end">{formatCurrency(parseFloat(i.LineAmount) + parseFloat(i.TaxAmount))}</td>
          </tr>
          </>
        ))}

      </tbody>
    </table>
    <div className="border-bottom2 my-2"></div>
    <table className="table table-sm" style={{ maxWidth: "302px", fontSize:"15px"}}>
      <tbody>
      <tr>
        <td className="text-start font-weight-bold" colSpan="2">
          <Trans>Subtotal</Trans>
          {Number(invoice.TotalDiscount) > 0 ? (
            <>
              {" "}
              <Trans>
                (includes a discount of {invoice.DiscountRate ? `${invoice.DiscountRate}%` : null}
                {{ amount: formatCurrency(invoice.TotalDiscount) }})
              </Trans>
            </>
          ) : null}
        </td>
        <td className="c-text-end">
          <CurrencySymbol currency={invoice.CurrencyCode} value={formatCurrency(invoice.SubTotal)} />
        </td>
      </tr>
      <tr>
        <TaxPercent taxRates={taxRates} lineItem={invoice} />
        <td className="text-start font-weight-bold" colSpan="2">
          <Trans>TOTAL TAX</Trans>
        </td>
        <td className="c-text-end">
        <CurrencySymbol currency={invoice.CurrencyCode} value={formatCurrency(invoice.invoice)} />
        </td>
      </tr>
      <tr>
        <td className="text-start font-weight-bold" colSpan="2">
          <strong>
            <Trans>TOTAL (Including VAT)</Trans><span className="px-1"></span>
            <Trans></Trans>
          </strong>
        </td>
        <td className="c-text-end">
          <CurrencySymbol currency={invoice.CurrencyCode} value={formatCurrency(invoice.Total)} />
        </td>
      </tr>
      {/* {!invoice.InvoiceID && invoice.DueDateString ? (
        <tr>
          <td className="text-start font-weight-bold " colSpan="2">
            <strong>
              <Trans>DUE DATE</Trans>
            </strong>
          </td>
          <td className="c-text-end">
            <strong>{invoice.DueDateString}</strong>
          </td>
        </tr>
      ) : null} */}
      {!!(invoice.Payments && invoice.Payments.length) && (
        <tr>
          <td className="text-start font-weight-bold " colSpan="2">
            {invoice.InvoiceID ? (
              <Trans>Less Amount Paid</Trans>
            ) : (
              <Trans>Less Cash Refunded</Trans>
            )}
          </td>
          <td className="c-text-end">
            {formatCurrency(
              sumBy(invoice.Payments, (i) => parseFloat(i.Amount) || 0)
            )}
          </td>
        </tr>
      )}


      {!!(invoice.CreditNotes && invoice.CreditNotes.length) && (
        <tr>
          <td className="text-start " colSpan="2">
            <Trans>Less Amount Credited</Trans>
          </td>
          <td className="c-text-end ">
            {formatCurrency(
              sumBy(
                invoice.CreditNotes,
                (i) => parseFloat(i.AppliedAmount) || 0
              )
            )}
          </td>
        </tr>
      )}
      {!!(invoice.Overpayments && invoice.Overpayments.length) && (
        <tr>
          <td className="text-start " colSpan="2">
            <Trans>Less Overpayment Amount</Trans>
          </td>
          <td className="c-text-end ">
            {formatCurrency(
              sumBy(
                invoice.Overpayments,
                (i) => parseFloat(i.AppliedAmount) || 0
              )
            )}
          </td>
        </tr>
      )}
      {!!(invoice.Allocations && invoice.Allocations.length) && (
        <tr>
          <td className="text-start " colSpan="2">
            <Trans>Less Credit to Invoice(s)</Trans>
          </td>
          <td className="c-text-end ">
            {formatCurrency(
              sumBy(invoice.Allocations, (i) => parseFloat(i.Amount) || 0)
            )}
          </td>
        </tr>
      )}
      {!!(
        !isUndefined(invoice.AmountDue) && invoice.Total !== invoice.AmountDue
      ) && (
        <tr>
          <td className="text-start " colSpan="2">
            <strong>
              <Trans>AMOUNT DUE</Trans>
            </strong>
          </td>
          <td className="c-text-end ">
            <CurrencySymbol currency={invoice.CurrencyCode} value={formatCurrency(invoice.AmountDue)} />
          </td>
        </tr>
      )}
      {!isUndefined(invoice.RemainingCredit) && (
        <tr>
          <td className="text-start " colSpan="2">
            <strong>
              <Trans>Remaining Credit</Trans>
            </strong>
          </td>
          <td className="c-text-end ">
            <strong><CurrencySymbol currency={invoice.CurrencyCode} value={formatCurrency(invoice.RemainingCredit)} /> </strong>
          </td>
        </tr>
      )}
    </tbody>
  </table>
  </div>
</div>
);

export default withProps(({ includeDiscount }) => ({
  EmptyCells: ({ bordered, ...props }) => (
    <td
      colSpan={includeDiscount ? "4" : "3"}
      className={!bordered ? "border-top-0" : ""}
      {...props}
    />
  ),
}))(LineItems);
